import { useState, useContext } from "react";
import {
  Typography,
  Box,
  Grid,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TableContainer,
  Button,
} from "@mui/material";
import { useLocation } from "react-router-dom";
// Import from project
import "../../Style/pagestyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import {
  ButtonCreate,
  PageHeaderTitle,
  SearchTextField,
} from "../../Utils/Component";
import EmptyImage from "../../Assets/empty-image.png";
// import EmptyPDF from "../../Assets/pdf.png";
import EmptyData from "../../Components/Include/EmptyData/EmptyData";
import LoadingPage from "../../Utils/LoadingPage";
import FooterPagination from "../../Utils/FooterPagination";
import useWithDimension from "../../Hooks/useWithDimension";
import BookContentForm from "../../Components/BookContent/BookContentForm";
import BookContentAction from "../../Components/BookContent/BookContentAction";
import useGetBookContentPagination from "../../Hooks/useGetBookContentPagination";
import useGetOnlineBookById from "../../Hooks/useGetOnlineBookById";
import FileThumnail from "../../Utils/FileThumnail";
// import ViewFilePreview from "../../Utils/ViewFilePreview";

export default function BookContent() {
  const { t } = useContext(AuthContext);
  const { width } = useWithDimension();

  // Get classId from query parameters
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const bookId = params.get("bookId");

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // const [pdfData, setPdfData] = useState();
  // const [openView, setOpenView] = useState(false);
  // const handleOpenView = (data) => {
  //   setPdfData(data);
  //   setOpenView(true);
  // };
  // const handleCloseView = () => {
  //   setOpenView(false);
  // };

  const { bookData } = useGetOnlineBookById({ id: bookId });

  const {
    page,
    limit,
    setPage,
    refetch,
    loading,
    setLoading,
    handleSearch,
    tableData,
    paginationData,
    handleLimit,
  } = useGetBookContentPagination({ bookId: bookId });

  // console.log("tableData::", tableData);

  return (
    <div className="page-container">
      <PageHeaderTitle
        classPage={t("class-page-title")}
        classSlash="slash-title"
        routeTo={"/setting/online-book"}
        pageTitle={t("page_online_book")}
        detailTitle={`${bookData?.groupFeeId?.title} : ${bookData?.groupFeeId?.price} $`}
      />

      <Box sx={{ marginTop: "20px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("search")}
            </Typography>
            <SearchTextField
              className={"text-field"}
              handleSearch={handleSearch}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={8} lg={9} xl={10}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn={"btn-create"}
              classIcon={"icon-add"}
            />
            {open && (
              <BookContentForm
                open={open}
                handleClose={handleClose}
                dialogTitle="Create"
                setRefetch={refetch}
                bookId={bookId}
              />
            )}
          </Grid>
        </Grid>
      </Box>

      {/* {openView && (
        <ViewFilePreview
          readPdf={pdfData}
          open={openView}
          handleClose={handleCloseView}
        />
      )} */}

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table">
            <TableHead className="header-row">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width={"8%"}
                >
                  {t("thead_page_number")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title")}
                  width={"25%"}
                >
                  {t("thead_title")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title")}
                  width={"12%"}
                >
                  {t("thead_profile")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title")}
                  width={"45%"}
                >
                  {t("thead_description")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title-end")}
                  width={"10%"}
                  align="right"
                ></TableCell>
              </TableRow>
            </TableHead>

            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={12} className="body-cell" align="center">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody className="body">
                {!tableData || tableData.length === 0 ? (
                  <TableRow className="body-row">
                    <TableCell
                      colSpan={12}
                      className="body-cell"
                      align="center"
                    >
                      <EmptyData />
                    </TableCell>
                  </TableRow>
                ) : (
                  tableData.map((row, index) => (
                    <TableRow className="body-row" key={row?._id || index}>
                      <TableCell className="body-cell-start">
                        {row?.pageNumber || "-- : --"}
                      </TableCell>
                      <TableCell className="body-cell">{row?.title}</TableCell>
                      <TableCell className="body-cell">
                        {row?.fileType === "image" && (
                          <img
                            alt="lesson-preview"
                            style={{
                              width: "80px",
                              height: "80px",
                              borderRadius: "4px",
                              objectFit: "cover",
                              display: "inline-block",
                              verticalAlign: "middle",
                            }}
                            src={row?.file || EmptyImage}
                          />
                        )}

                        {row?.fileType === "pdf" && (
                          <Button
                            component="a"
                            href={row?.file}
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                            aria-label="Download PDF"
                          >
                            <FileThumnail
                              pdfFile={row?.file}
                              width="80px"
                              height="80px"
                            />
                          </Button>
                        )}
                      </TableCell>
                      <TableCell className="body-cell">
                        {row?.description}
                      </TableCell>
                      <TableCell className="body-cell-end" align="right">
                        <BookContentAction
                          setRefetch={refetch}
                          editData={row}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>

        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
